import request from '@/utils/request'
const getCourseCatalogTreeList = (courseId) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-catalog/tree-list/${courseId}`,
    method: 'get'
  })
}

const getCourseCatalogById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-catalog/${id}`,
    method: 'get'
  })
}

function createCourseCatalog(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-catalog`,
    method: 'post',
    data
  })
}

const updateCourseCatalog = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-catalog/${id}`,
    method: 'put',
    data
  })
}

const deleteCourseCatalog = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/course-catalog/${id}`,
    method: 'delete'
  })
}

export default {
  getCourseCatalogTreeList,
  getCourseCatalogById,
  createCourseCatalog,
  updateCourseCatalog,
  deleteCourseCatalog
}
